
export const state = {
  visible1: true,
  visible2: true,
  visible3: true,
  visible4: true,
  visible5: true,
  visible6: true,
  visible7: true,

  afterVisible1: false,
  afterVisible2: false,
  afterVisible3: false,
  afterVisible4: false,
  afterVisible5: false,
  afterVisible6: false,
  afterVisible7: false,

  texture: false,
  texture2: false,
  texture3: false,
  texture4: false,
  texture5: false,
  texture6: false,
  texture7: false,
  viewBG: false,

  color1: '#ffffff',
  color2: '#ffffff',
  color3: '#ffffff',
  color4: '#ffffff',
  color5: '#ffffff',
  color6: '#ffffff',
  color7: '#ffffff',

  opacity1: 1.0,
  opacity2: 1.0,
  opacity3: 1.0,
  opacity4: 0.7,
  opacity5: 0.7,
  opacity6: 0.7,
  opacity7: 0.7,

  uniforms: {},
  bloom: {
    threshold: 0.93,
    strength: 1.5,
    radius: 1.0
  }
}
/*
Number(0.86)
bloomPass.threshold = Number(0.37)
bloomPass.strength = Number(1.0)
bloomPass.radius = Number(1.0)
*/



// WEBPACK FOOTER //
// ./src/components/Pages/KeyRemixer/remixer.js